<template>
  <div>
    <v-card class="mt-3">
      <v-card-title class="blue-grey lighten-4" dark>
        <span class="headline font-weight-regular">Dashboard de Pagamento</span>
      </v-card-title>
      <template>
        <div>
          <v-container fluid>
            <v-layout row wrap justify-center>
              <v-flex md2 xs3 style="padding: 0px 20px;">
                <v-autocomplete
                  label="Empresa"
                  item-text="nome"
                  item-value="id"
                  :items="empresas.content"
                  v-model="idEmpresa"
                  no-data-text="Não encontramos empresa"
                ></v-autocomplete>
              </v-flex>
              <v-flex md2 xs6 style="padding: 0px 20px;">
                <c-seletor-data 
                  nomeDoCampo="Data inicial" 
                  @pegarData="(dataInserida) => dataInicio = dataInserida"
                  @validacaoFormulario="(formularioValidado) => validacaoDataInicio = formularioValidado"
                  :dataMaxima="dataFim" 
                  :data="dataInicio"
                  :regras="regraDeLimiteDeData">
                </c-seletor-data>
              </v-flex>
              <v-flex md2 xs6 style="padding: 0px 20px;">
                <c-seletor-data 
                  nomeDoCampo="Data final"  
                  @pegarData="(dataInserida) => dataFim = dataInserida"
                  @validacaoFormulario="(formularioValidado) => validacaoDataFim = formularioValidado"
                  :dataMinima="dataInicio"
                  :data="dataFim"
                  :regras="regraDeLimiteDeData"> 
                </c-seletor-data>
              </v-flex>
              <v-flex md3 xs6 style="padding: 0px 20px;">
                <v-autocomplete
                  label="Selecione o Status"
                  item-text="nome"
                  item-value="valor"
                  :items="listaDeStatus"
                  v-model="status"
                  no-data-text="Não encontramos este status"
                ></v-autocomplete>
              </v-flex>
              <v-flex md1 xs6>
                <v-btn color="#005ca3" @click="() => {
                    if(validarCamposDoFiltro) {
                      filtrar()
                    }
                  }">
                  <span class="white--text">Filtrar</span>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </div>
      </template>
    </v-card>

    <div v-if="!loading" class="mt-3">
      <v-layout row wrap v-if="this.dados.length > 0">
        <v-flex xs4 class="pl-0">
          <v-card>
            <v-card-title
              class="blue-grey"
              primary-title
              style="display: block; text-align: center;"
            >
              <span
                style="text-align: center;"
                class="headline font-weight-regular white--text"
              >Fornecedores</span>
            </v-card-title>
            <v-card-title>
              <v-layout row wrap>
                <v-flex md12 lg12>
                  <h2 class="title mb-3 font-weight-light">
                    Nacionais
                    <v-tooltip bottom class="paddingTooltip">
                      <v-icon slot="activator" @click="visualizarPedido(props.item)">info</v-icon>
                      <span>Cálculo de todos os pagamentos para PJ e PF (somente moeda nacional R$).</span>
                    </v-tooltip>
                  </h2>
                  <div
                    class="d-block mb-3"
                    v-for="(pagamento, index) in this.dados.filter(i => i.pagamento == 'PAGAMENTO_PARA_FORNECEDOR_NACIONAL')"
                    :key="index"
                  >
                    <p
                      class="local-moeda display-1 mb-2 pb-0 font-weight-bold"
                    >{{ converterParaMoedaReal(pagamento.total, 'BRL') }}</p>
                    <p class="text--italic">Quantidade: {{ pagamento.quantidadeDePagamentos }}</p>
                  </div>
                </v-flex>
                <v-flex md12 lg12>
                  <v-divider></v-divider>
                </v-flex>
                <v-flex md12 lg12>
                  <h2 class="title mb-3 mt-3 font-weight-light">
                    Estrangeiros
                    <v-tooltip bottom class="paddingTooltip">
                      <v-icon slot="activator" @click="visualizarPedido(props.item)">info</v-icon>
                      <span>Cálculo de todos os pagamentos para fornecedor Estrangeiro (qualquer moeda).</span>
                    </v-tooltip>
                  </h2>
                  <div
                    class="d-block mb-3"
                    v-for="(pagamento, index) in this.dados.filter(i => i.pagamento == 'PAGAMENTO_PARA_FORNECEDOR_ESTRANGEIRO')"
                    :key="index"
                  >
                    <p
                      class="local-moeda display-1 mb-2 pb-0 font-weight-bold"
                    >{{ converterParaMoedaReal(pagamento.total, 'USD') }}</p>
                    <p class="text--italic">Quantidade: {{ pagamento.quantidadeDePagamentos }}</p>
                  </div>
                </v-flex>
              </v-layout>
            </v-card-title>
          </v-card>
        </v-flex>

        <v-flex xs4>
          <v-card>
            <v-card-title
              class="blue-grey lighten-2"
              primary-title
              style="display: block; text-align: center;"
            >
              <span
                style="text-align: center;"
                class="headline font-weight-regular white--text"
              >Colaboradores</span>
            </v-card-title>
            <v-card-title>
              <v-layout row wrap>
                <v-flex md12 lg12>
                  <h2 class="title mb-3 font-weight-light">
                    Nacionais
                    <v-tooltip bottom class="paddingTooltip">
                      <v-icon slot="activator" @click="visualizarPedido(props.item)">info</v-icon>
                      <span>Cálculo de todos os pagamentos para PF (somente moeda nacional R$).</span>
                    </v-tooltip>
                  </h2>
                  <div
                    class="d-block"
                    v-for="(pagamento, index) in this.dados.filter(i => i.pagamento == 'PAGAMENTO_PARA_COLABORADOR_EM_MOEDA_NACIONAL')"
                    :key="index"
                  >
                    <p
                      class="local-moeda display-1 mb-2 pb-0 font-weight-bold"
                    >{{ converterParaMoedaReal(pagamento.total, 'BRL') }}</p>
                    <p class="mt-0 pt-0">Quantidade: {{ pagamento.quantidadeDePagamentos }}</p>
                  </div>
                </v-flex>
                <v-flex md12 lg12>
                  <v-divider></v-divider>
                </v-flex>
                <v-flex md12 lg12>
                  <h2 class="title mb-3 mt-3 font-weight-light">
                    Estrangeiros
                    <v-tooltip bottom class="paddingTooltip">
                      <v-icon slot="activator" @click="visualizarPedido(props.item)">info</v-icon>
                      <span>Cálculo de todos os pagamentos para PF (menos moeda nacional R$).</span>
                    </v-tooltip>
                  </h2>
                  <div
                    class="d-block mb-3"
                    v-for="(pagamento, index) in this.dados.filter(i => i.pagamento == 'PAGAMENTO_PARA_COLABORADOR_EM_MOEDA_ESTRANGEIRA')"
                    :key="index"
                  >
                    <p
                      class="local-moeda display-1 mb-2 pb-0 font-weight-bold"
                    >{{ converterParaMoedaReal(pagamento.total, 'USD') }}</p>
                    <p class="mt-0 pt-0">Quantidade: {{ pagamento.quantidadeDePagamentos }}</p>
                  </div>
                </v-flex>
              </v-layout>
            </v-card-title>
          </v-card>
        </v-flex>

        <v-flex xs4 class="pr-0">
          <v-card class="fill-height">
            <v-card-title
              class="blue-grey lighten-4"
              primary-title
              style="display: block; text-align: center;"
            >
              <span style="text-align: center;" class="headline font-weight-regular">Totais</span>
            </v-card-title>
            <v-card-title>
              <v-layout row wrap>
                <v-flex md12 lg12>
                  <h2 class="title mb-3 font-weight-light">
                    Nacionais
                    <v-tooltip bottom class="paddingTooltip">
                      <v-icon slot="activator" @click="visualizarPedido(props.item)">info</v-icon>
                      <span>Cálculo de todos pagamentos nacionais de Fornecedores e Colaboradores.</span>
                    </v-tooltip>
                  </h2>
                  <div class="d-block">
                    <p
                      style="color: #005ca3 !important;"
                      class="local-moeda mb-2 display-1 font-weight-bold"
                    >{{ converterParaMoedaReal(somaPagamentosNacionais) }}</p>
                    <p class="mt-0 pt-0">Quantidade: {{ somaQuantidade('nacional') }}</p>
                  </div>
                </v-flex>
                <v-flex md12 lg12>
                  <v-divider></v-divider>
                </v-flex>
                <v-flex md12 lg12>
                  <h2 class="title mb-3 mt-3 font-weight-light">
                    Estrangeiros
                    <v-tooltip bottom class="paddingTooltip">
                      <v-icon slot="activator" @click="visualizarPedido(props.item)">info</v-icon>
                      <span>Cálculo de todos os pagamentos estrangeiros de Fornecedores e Colaboradores.</span>
                    </v-tooltip>
                  </h2>
                  <div class="d-block">
                    <p
                      style="color: #005ca3 !important;"
                      class="local-moeda mb-2 display-1 font-weight-bold"
                    >{{ converterParaMoedaReal(somaPagamentosEstrangeiros, 'USD') }}</p>
                    <p class="mt-0 pt-0">Quantidade: {{ somaQuantidade('estrangeiro') }}</p>
                  </div>
                </v-flex>
              </v-layout>
            </v-card-title>
          </v-card>
        </v-flex>

        <v-flex xs12 class="pa-0">
          <v-data-table
            class="mt-3"
            hide-actions
            no-data-text="Sem dados carregados."
            :loading="loadingPagamentos"
            :headers="headersPagamentos"
            :items="pagamentos.content"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.empresa }}</td>
              <td>{{ props.item.fornecedor }}</td>
              <td>{{ props.item.numeroDoPedido }}</td>
              <td>{{ formataTipo(props.item.tipoDePagamento) }}</td>
              <td>{{ converterParaMoedaReal(props.item.valor, props.item.tipoDeMoeda) }}</td>
              <td>{{ valoresDePagamento(props.item.valor, verificarSePagamentoEhParcelado(props.item) , props.item.tipoDeMoeda) }}</td>
              <td>{{ props.item.solicitante }}</td>
              <td v-html="retornaStatus(props.item.status)"></td>
              <td class="text-xs-center">
                <v-tooltip bottom class="paddingTooltip">
                  <v-icon
                    small
                    class="mr-2"
                    slot="activator"
                    @click="visualizarPedido(props.item)"
                  >visibility</v-icon>

                  <span>Visualizar</span>
                </v-tooltip>
              </td>
            </template>
          </v-data-table>

          <div class="text-xs-center">
            <v-pagination
              @input="filtrarPagamentos($event)"
              v-model="pagination.page"
              :length="pagination.total"
            ></v-pagination>
          </div>
        </v-flex>
      </v-layout>

      <v-layout row wrap v-else class="mt-3">
        <v-flex xs12>
          <h1
            class="title"
            style="text-align: center !important"
          >Nenhum resultado foi encontrado com sua base de busca.</h1>
        </v-flex>
      </v-layout>
    </div>

    <v-layout row wrap class="mt-10 mt-5 justify-center" v-else>
      <v-progress-circular :size="150" :width="10" indeterminate color="primary">Carregando</v-progress-circular>
    </v-layout>
  </div>
</template>
<script>
import { mapState } from "vuex";
import axios from "axios";
import moedasMixins from "../../mixins/moedasMixin";
import SeletorData from "../shared/SeletorData";

export default {
  data() {
    return {
      idEmpresa: 1,
      status: "",
      dados: [],
      dataInicio: "",
      dataFim: "",
      loading: false,
      pagamentos: [],
      pagination: {
        page: 1,
        total: 0
      },
      parametros: "",
      headersPagamentos: [
        { text: "Empresa", value: "empresa", sortable: true, align: "left" },
        { text: "Fornecedor", value:"fornecedor", sortable: true, align: "left" },
        { text: "Nº Pedido", value:"numeroDoPedido", sortable: false, align: "left" },
        { text: "Tipo", value:"tipoDePagamento", sortable: true, align: "left" },
        { text: "Valor", value:"valor", sortable: true, align: "left" },
        { text: "Valor Líquido", value:"valorLiquido", sortable: true, align: "left"},
        { text: "Solicitante", value:"solicitante", sortable: true, align: "left" },
        { text: "Status", value:"status", sortable: true, align: "center" },
        { text: "Ações", sortable: false, align: "center" }
      ],
      loadingPagamentos: false,
      regraDeLimiteDeData: [ data => data.length >= 8 || "Digite uma data válida"],
      form: false,
      validacaoDataInicio: false,
      validacaoDataFim: false
    };
  },
  created() {
    if (this.empresas.length == 0) {
      this.$store.dispatch("get", {
        loaderName: "loadingCompanies",
        service: "/empresas",
        itemName: "empresas"
      });
    }

    if (localStorage.hasOwnProperty("camposFiltros")) {
      let filtroCache = JSON.parse(localStorage.getItem("camposFiltros"));
      Object.keys(filtroCache).map(i => {
        this[i] = filtroCache[i];
      });
    } else {
      this.dataInicio = new Date().toISOString().split("T")[0];
      this.dataFim = new Date().toISOString().split("T")[0];
    }

    this.filtrar();
  },
  computed: {
    ...mapState({
      loggedUser: state => state.loggedUser,
      empresas: state => state.empresas,
      listaDeStatus: state => state.listaDeStatus
    }),
    dataMinima() {
      let dataDeHoje = new Date();
      dataDeHoje = dataDeHoje.getFullYear() - 1;
      return `${dataDeHoje}-01-01`;
    },
    somaPagamentosNacionais() {
      let soma = 0;
      this.dados.map(d => {
        if (
          d.pagamento == "PAGAMENTO_PARA_COLABORADOR_EM_MOEDA_NACIONAL" ||
          d.pagamento == "PAGAMENTO_PARA_FORNECEDOR_NACIONAL"
        ) {
          soma += d.total;
        }
      });
      return soma;
    },
    somaPagamentosEstrangeiros() {
      let soma = 0;
      this.dados.map(d => {
        if (
          d.pagamento == "PAGAMENTO_PARA_COLABORADOR_EM_MOEDA_ESTRANGEIRA" ||
          d.pagamento == "PAGAMENTO_PARA_FORNECEDOR_ESTRANGEIRO"
        ) {
          soma += d.total;
        }
      });
      return soma;
    },
    validarCamposDoFiltro(){
      if(this.validacaoDataInicio && this.validacaoDataFim) return true
      else return false
    }
  },
  methods: {
    formataTipo(tipo) {
      if (tipo == "PAGAMENTO") return "Pagamento";
      if (tipo == "PrestacaoDeContas") return "Prestação de Contas";

      return tipo;
    },
    /**
     * @param {Int} valorLiquido: Valor liquido.
     * @param {Int} valorBruto: Valor bruto.
     * @param {Array} tipoDeMoeda: Tipo da moeda a ser convertida.
     */
    valoresDePagamento(valorBruto, valorLiquido, tipoDeMoeda){
      if(typeof(valorLiquido) === "number"){
        const converterValorLiquido = moedasMixins.methods.converterParaMoedaReal(valorLiquido, tipoDeMoeda);
        return converterValorLiquido;
      }
      const converterValorBruto = moedasMixins.methods.converterParaMoedaReal(valorBruto, tipoDeMoeda);
      return converterValorBruto
    },

    somaQuantidade(tipo) {
      let soma = 0;
      this.dados.map(d => {
        let valorPraSomar = 0;
        if (tipo == "estrangeiro") {
          if (
            d.pagamento == "PAGAMENTO_PARA_COLABORADOR_EM_MOEDA_ESTRANGEIRA" ||
            d.pagamento == "PAGAMENTO_PARA_FORNECEDOR_ESTRANGEIRO"
          )
            valorPraSomar = d.quantidadeDePagamentos;
        } else {
          if (
            d.pagamento == "PAGAMENTO_PARA_FORNECEDOR_NACIONAL" ||
            d.pagamento == "PAGAMENTO_PARA_COLABORADOR_EM_MOEDA_NACIONAL"
          )
            valorPraSomar = d.quantidadeDePagamentos;
        }
        soma += valorPraSomar;
      });
      return soma;
    },
    visualizarPedido(item) {
      const { tipoDePagamento } = item;
      const { id } = item;
      const ehPedidoFornecedor = tipoDePagamento === "ADIANTAMENTO" || tipoDePagamento === "PAGAMENTO"
       if (tipoDePagamento === "Reembolso")
        this.$router.push({ path: `/pedidos/reembolsos/${id}` });

      if (tipoDePagamento === "PrestacaoDeContas")
        this.$router.push({ path: `/pedidos/prestarcontas/${id}` });
      
      if(ehPedidoFornecedor) this.$router.push({ path: `/pagamentos/fornecedores/${id}` });
      else this.$router.push({ path: `/pedidos/adiantamentos/${id}` });
    },
    filtrar() {
      localStorage.setItem(
        "camposFiltros",
        JSON.stringify({
          dataInicio: this.dataInicio,
          dataFim: this.dataFim,
          status: this.status,
          idEmpresa: this.idEmpresa
        })
      );
      this.parametros = `dataInicio=${this.dataInicio}&dataFim=${this.dataFim}&status=${this.status}&empresa=${this.idEmpresa}`;
      let urlIndicadores = `/dashboard/indicadores/busca?` + this.parametros;
      this.loading = true;
      this.fazerRequest(urlIndicadores)
        .then(s => {
          this.dados = s.data;
        })
        .finally(s => {
          this.loading = false;
        });
      this.filtrarPagamentos(1);
    },
    filtrarPagamentos(pagina) {
      this.pagination.page = pagina;
      let urlPagamentos =
        `/dashboard/pagamentos/busca?` +
        this.parametros +
        `&pagina=${this.pagination.page - 1}&size=15`;
      this.loadingPagamentos = true;
      this.fazerRequest(urlPagamentos)
        .then(s => {
          this.pagamentos = s.data;
          this.pagination.total = s.data.totalPages;
        })
        .finally(f => (this.loadingPagamentos = false));
    },
    retornaStatus(statusRecebido) {
      let classe = "";
      let nome = "";
      this.listaDeStatus.map(i => {
        if (i.valor == statusRecebido) {
          nome = i.nome;
          classe = i.classe;
        }
      });
      return `<p class="${classe} pt-2">${nome}</p>`;
    },
    async fazerRequest(url, tipo, objeto) {
      let headers = {
        Authorization: `Bearer ${this.loggedUser.token}`,
        Accept: "application/json",
        "Content-Type": "application/json"
      };
      let dataEnvio = "";

      if (tipo == undefined) tipo = "get";
      else {
        dataEnvio = JSON.stringify(objeto);
      }
      return await axios({
        method: tipo,
        url: `${url}`,
        responseType: "json",
        headers,
        data: dataEnvio
      })
        .then(function(response) {
          return response;
        })
        .catch(e => {
          this.dados = [];
        })
        .finally(s => {});
    },
    verificarSePagamentoEhParcelado(pagamento){
      return pagamento.ehParcelado ? pagamento.valorDaParcelaDoMes : pagamento.valorLiquido;
    }
  },
  mixins: [moedasMixins],
  components: {
    "c-seletor-data": SeletorData,
  }
};
</script>
<style scoped>
.color-catho {
  color: #ff0d7b;
}
.d-block {
  display: block;
  border-bottom: 1px solid white;
}

.local-moeda {
  /*font-size: 3em !important;*/
  letter-spacing: -3px !important;
  color: #ff0d7b;
}

.d-block:last-child {
  border-bottom: 0px;
}
</style>